export default "/assets/images/air-changes-graph-lg.0a6560fdff49aa56.svg";